import { render, staticRenderFns } from "./staff.vue?vue&type=template&id=861a8e58&scoped=true&"
import script from "./staff.vue?vue&type=script&lang=js&"
export * from "./staff.vue?vue&type=script&lang=js&"
import style0 from "./staff.vue?vue&type=style&index=0&id=861a8e58&lang=scss&scoped=true&"
import style1 from "./staff.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861a8e58",
  null
  
)

export default component.exports